import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, utils,
} from '@resy/ui-kitchen';
import AmexGDAOffersTerms from '../AmexGDAOffersTerms';
import AmexGDAOffersBenefits from '../AmexGDAOffersBenefits';
import AmexGDAOffersApplyNow from '../AmexGDAOffersApplyNow';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexGDAOffersCards.scss';
import { ACQUISITION_CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';

const DELTA_CARD_ID = '6';
const HILTON_CARD_ID = '7';
const PLAT_CARD_ID = '1';

export const getCampaignId = (queryString) => {
  if (!queryString || typeof queryString !== 'string') return null;
  const params = new URLSearchParams(queryString);

  const source = params.get('utm_source') || '';
  const medium = params.get('utm_medium') || '';
  const campaign = params.get('utm_campaign') || '';

  if (!source && !medium && !campaign) return null;

  const extlink = `${source}-${medium}-${campaign}`;
  return extlink ? `&extlink=${extlink}` : null;
};
const AmexGDAOffersCards = (props) => {
  const {
    offersResyData, showNaa2025, baseRequestUrl, newGdaAllCardProductOrder,
    platCardProps, referrer, Analytics, clickShowDetails, isDesktopMedia,
  } = props;

  const {
    showPlatOfferDetails,
    amexCardData,
    resyCardData,
  } = platCardProps;

  const {
    imagePath,
    marketingContent,
    productName,
  } = amexCardData;

  const {
    offerBadge,
    offerBadgeNew,
    showMoreLabel,
    showLessLabel,
  } = resyCardData;

  const getGridColumnsExtraCards = (cardOrder) => {
    let gridColumns = 0;

    const gdaAllCardOrderArray = cardOrder.split(',');
    if (gdaAllCardOrderArray.length === 3) {
      gridColumns = 3;
    } else if (gdaAllCardOrderArray.length === 2) {
      gridColumns = 2;
    }

    return gridColumns;
  };

  const clickLearnMore = (cardId, gdaAdditionalProducts) => {
    const cardObj = gdaAdditionalProducts.find((element) => element.card_id === cardId) || {};
    const { card_cta_link: cardCtaLink, card_cta_campaign_link: cardCtaCampaignLink } = cardObj;
    const campaignString = getCampaignId(cardCtaCampaignLink);
    const utmValues = cardCtaCampaignLink;
    let referrerValue = '';
    if (referrer) {
      referrerValue = `&referring_domain=${referrer}`;
    }

    const actionName = (cardId === DELTA_CARD_ID) ? 'NAA - Delta View Details CTA Click' : 'NAA - Hilton View Details CTA Click';

    handleMktAnalytics(Analytics.event, ACQUISITION_CTA_EVENT_NAME, { action_name: actionName });

    const ctalink = cardCtaLink.concat(utmValues).concat(campaignString).concat(referrerValue);
    utils.openExternalUrl(ctalink);
  };

  const {
    additional_products: additionalProducts,
  } = offersResyData;

  const deltaPresent = newGdaAllCardProductOrder.indexOf(DELTA_CARD_ID) > -1;
  const hiltonPresent = newGdaAllCardProductOrder.indexOf(HILTON_CARD_ID) > -1;

  let gdaDeltaData = {};
  let gdaHiltonData = {};

  if (additionalProducts) {
    additionalProducts.map((item) => {
      if (item.card_id === DELTA_CARD_ID && deltaPresent) {
        gdaDeltaData = {
          deltaCard: item.card_image_file_name,
          deltaText: item.card_title,
          deltaLearnMoreLabel: item.card_cta_label,
          deltaBadgeCopy: item.card_badge_copy,
          deltaOffersCopy: item.card_offer_copy,
        };
      }
      if ((item.card_id === HILTON_CARD_ID && hiltonPresent)) {
        gdaHiltonData = {
          hiltonCard: item.card_image_file_name,
          hiltonText: item.card_title,
          hiltonLearnMoreLabel: item.card_cta_label,
          hiltonBadgeCopy: item.card_badge_copy,
          hiltonOffersCopy: item.card_offer_copy,
        };
      }
      return null;
    });
  }

  const sanitizedDeltaText = sanitizeString(gdaDeltaData?.deltaText);
  const sanitizedDeltaOffersCopy = sanitizeString(gdaDeltaData?.deltaOffersCopy);
  const sanitizedProductName = sanitizeString(productName);
  const sanitizedMarketingContentText = sanitizeString(marketingContent.display_text?.[0].text);
  const sanitizedHiltonOffersCopy = sanitizeString(gdaHiltonData.hiltonOffersCopy);

  const gridColumns = getGridColumnsExtraCards(newGdaAllCardProductOrder);

  if (!deltaPresent && !hiltonPresent) {
    return null;
  }
  let deltaOrder = 0;
  let platOrder = 0;
  let hiltonOrder = 0;

  const newAllCardOrderArray = newGdaAllCardProductOrder.split(',');
  newAllCardOrderArray.forEach((item, index) => {
    if (item === PLAT_CARD_ID) platOrder = index;
    else if (item === DELTA_CARD_ID) deltaOrder = index;
    else if (item === HILTON_CARD_ID) hiltonOrder = index;
  });

  const renderShowDetailsInGDA = () => (
    <Button
      id="showMoreBtn"
      variant="no-style"
      onClick={() => {
        const link = showPlatOfferDetails ? '#platinumoffer' : '#showMoreBtn';
        clickShowDetails(link);
      }}
      className="AmexGDAOffersCards__showmorelink"
      aria-label="The Platinum Card® GDA Link"
      aria-expanded={showPlatOfferDetails}
      type="button"
    >
      {!showPlatOfferDetails ? showMoreLabel : showLessLabel }
    </Button>
  );

  return (
    <>
      {deltaPresent && (
      <li
        className={`cards-${gridColumns} order-${deltaOrder}`}
      >
        <div className="AmexGDAOffersCards__extracarddetails delta">
          {(isDesktopMedia && showNaa2025) && (
            <h3
              className="AmexGDAOffersCards__extracarddetails__heading heading-top"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedDeltaText,
              }}
            />
          )}
          <div className="AmexGDAOffersCards__extracarddetails__container">
            <div className="AmexGDAOffersCards__card--wrapper">
              <img
                className="delta"
                src={`${baseRequestUrl}GDA/Offers/images/${gdaDeltaData.deltaCard}`}
                alt="GDA Delta Card"
              />
              {(!isDesktopMedia || (isDesktopMedia && !showNaa2025)) && (
                <h3
                  className="AmexGDAOffersCards__extracarddetails__heading"
                  dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                    __html: sanitizedDeltaText,
                  }}
                />
              )}
              <div className="AmexGDAOffersCards__card__wrapperBadge">
                {gdaDeltaData.deltaBadgeCopy
                 && (<p className="AmexGDAOffersCards__card__badge offersBadge">{gdaDeltaData.deltaBadgeCopy}</p>)}
              </div>
              {gdaDeltaData.deltaOffersCopy && (
              <div
                className="AmexGDAOffersCards__card--text"
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedDeltaOffersCopy,
                }}
              />
              )}
            </div>
            <div className="AmexGDAOffersCards__card--wrapperBottom">
              <Button
                id="delta"
                className="AmexGDAOffersCards__extracarddetails__button-delta Button Button--primary"
                onClick={() => clickLearnMore(DELTA_CARD_ID, additionalProducts)}
                aria-label={gdaDeltaData.deltaLearnMoreLabel}
                type="button"
              >
                {gdaDeltaData.deltaLearnMoreLabel}
              </Button>
            </div>
          </div>
        </div>
      </li>
      )}
      {platCardProps && (
      <li className={`cards-${gridColumns} order-${platOrder}`}>
        <div className="AmexGDAOffersCards__extracarddetails">
          {((isDesktopMedia && productName) && showNaa2025) && (
            <h3
              className="AmexGDAOffersCards__extracarddetails__heading heading-top"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedProductName,
              }}
            />
          )}
          <div className="AmexGDAOffersCards__extracarddetails__container">
            <div className="AmexGDAOffersCards__card--wrapper">
              <img
                className="plat"
                src={imagePath}
                alt="GDA Platinum Card"
              />
              {(productName && (!isDesktopMedia || (isDesktopMedia && !showNaa2025)))
              && (
                <h3
                  className="AmexGDAOffersCards__extracarddetails__heading"
                  dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                    __html: sanitizedProductName,
                  }}
                />
              )}
              <div className="AmexGDAOffersCards__card__wrapperBadge">
                { showNaa2025
                  ? offerBadgeNew && (<p className="AmexGDAOffersCards__card__badge offersBadge">{offerBadgeNew}</p>)
                  : offerBadge && (<p className="AmexGDAOffersCards__card__badge offersBadge">{offerBadge}</p>)}
              </div>
              <div
                className="AmexGDAOffersCards__card--text"
                key={marketingContent.sequence_order}
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedMarketingContentText,
                }}
              />
              <AmexGDAOffersTerms
                {...platCardProps}
                Analytics={Analytics}
              />
            </div>
            <div className="AmexGDAOffersCards__card--wrapperBottom">
              <AmexGDAOffersApplyNow
                {...platCardProps}
                Analytics={Analytics}
              />
              {renderShowDetailsInGDA()}
            </div>
          </div>
          {!isDesktopMedia && showPlatOfferDetails && (
            <div className="AmexGDAOffersCards__mobileBenefits plat">
              <AmexGDAOffersBenefits
                {...platCardProps}
                isDesktopMedia={isDesktopMedia}
                Analytics={Analytics}
                clickShowDetails={clickShowDetails}
              />
            </div>
          )}
        </div>
      </li>
      )}
      {hiltonPresent && (
      <li
        className={`cards-${gridColumns} order-${hiltonOrder}`}
      >
        <div className="AmexGDAOffersCards__extracarddetails hilton">
          {(isDesktopMedia && showNaa2025) && (
            <h3 className="AmexGDAOffersCards__extracarddetails__heading heading-top">
              {gdaHiltonData.hiltonText}
            </h3>
          )}
          <div className="AmexGDAOffersCards__extracarddetails__container">
            <div className="AmexGDAOffersCards__card--wrapper">
              <img
                className="hilton"
                src={`${baseRequestUrl}GDA/Offers/images/${gdaHiltonData.hiltonCard}`}
                alt="GDA Hilton Card"
              />
              {(!isDesktopMedia || (isDesktopMedia && !showNaa2025)) && (
                <h3 className="AmexGDAOffersCards__extracarddetails__heading">
                  {gdaHiltonData.hiltonText}
                </h3>
              )}
              <div className="AmexGDAOffersCards__card__wrapperBadge">
                {gdaHiltonData.hiltonBadgeCopy && (<p className="AmexGDAOffersCards__card__badge offersBadge">{gdaHiltonData.hiltonBadgeCopy}</p>)}
              </div>
              {gdaHiltonData.hiltonOffersCopy && (
              <div
                className="AmexGDAOffersCards__card--text"
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedHiltonOffersCopy,
                }}
              />
              )}
            </div>
            <div className="AmexGDAOffersCards__card--wrapperBottom">
              <Button
                id="hilton"
                className="AmexGDAOffersCards__extracarddetails__button-hilton Button Button--primary"
                onClick={() => clickLearnMore(HILTON_CARD_ID, additionalProducts)}
                aria-label={gdaHiltonData.hiltonLearnMoreLabel}
                type="button"
              >
                {gdaHiltonData.hiltonLearnMoreLabel}
              </Button>
            </div>
          </div>
        </div>
      </li>
      )}
    </>
  );
};

AmexGDAOffersCards.defaultProps = {
  offersResyData: {
    all_card_product_order: '',
    additional_products: [],
  },
};

AmexGDAOffersCards.propTypes = {
  offersResyData: PropTypes.shape({
    all_card_product_order_mobile: PropTypes.string.isRequired,
    all_card_product_order_desktop: PropTypes.string.isRequired,
    additional_products: PropTypes.arrayOf(PropTypes.object),
  }),
  baseRequestUrl: PropTypes.string.isRequired,
  referrer: PropTypes.string.isRequired,
  newGdaAllCardProductOrder: PropTypes.string.isRequired,
  isDesktopMedia: PropTypes.bool.isRequired,
  platCardProps: PropTypes.shape({
    showPlatOfferDetails: PropTypes.bool.isRequired,
    amexCardData: PropTypes.shape({
      imagePath: PropTypes.string.isRequired,
      marketingContent: PropTypes.shape({
        sequence_order: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        display_text: PropTypes.arrayOf(PropTypes.shape({
          text: PropTypes.string.isRequired,
        })),
      }).isRequired,
      productName: PropTypes.string.isRequired,
    }).isRequired,
    resyCardData: PropTypes.shape({
      offerBadge: PropTypes.string.isRequired,
      offerBadgeNew: PropTypes.string.isRequired,
      showMoreLabel: PropTypes.string.isRequired,
      showLessLabel: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  clickShowDetails: PropTypes.func.isRequired,
  showNaa2025: PropTypes.bool.isRequired,
};

export default AmexGDAOffersCards;
